import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { spacing, FontFamily, typographyScale, TypographyVariant } from 'common/theme';

export const FormFieldWrapper = ({ label, children, testID, disabled = false, error = false, helperText, sx }) => {
  const theme = useTheme();
  return (
    <Box
      testId={testID}
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: `${spacing.xs}px`,
        marginBottom: { 
          xs: error && helperText ? `${spacing.lg}px` : `${spacing.xxl}px`, 
          md: error && helperText ? `${spacing.sm}px` : `${spacing.md}px` 
        },
        ...(disabled && {
          filter: 'grayscale(100%)',
          opacity: 0.7,
        }),
        ...sx,
      }}
    >
      {label && (
        <Typography
          sx={{
            fontFamily: FontFamily.regular,
            fontSize: typographyScale[TypographyVariant.BodyLarge].fontSize,
            lineHeight: typographyScale[TypographyVariant.BodyLarge].lineHeight,
            color: theme.palette.text.subtle,
          }}
        >
          {label}
        </Typography>
      )}
      {children}
      {helperText && (
        <Typography
          variant="caption"
          sx={{
            color: error ? theme.palette.error.main : theme.palette.text.subtle,
          }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default FormFieldWrapper;

